import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/carts',
      name: 'carts',
      component: () => import(/* webpackChunkName: "cart" */ './views/Carts.vue'),
    },
    {
      path: '/carts/add',
      name: 'addCart',
      component: () => import(/* webpackChunkName: 'addCart */ './views/cart/Add.vue'),
    },
    {
      path: '/carts/:id',
      name: 'viewCart',
      component: () => import(/* webpackChunkName: 'viewCart */ './views/cart/View.vue'),
    },
    {
      path: '/auth/success',
      name: 'authSuccess',
      component: () => import(/* webpackChunkName: "authentication" */ './views/auth/Success.vue'),
    },
    {
      path: '/auth/signin',
      name: 'authSignin',
      component: () => import(/* webpackChunkName: "authentication" */ './views/auth/SignIn.vue'),
    },
  ],
});
